import {
    GET_WEBLAB_START,
    GET_WEBLAB_COMPLETE,
    GetWeblabTreatmentComplete,
} from 'src/actions/WeblabAction';
import {GetWeblabTreatmentResponse} from "src/model/WeblabTreatment";
import RequestStatus from "src/model/RequestStatus";

const initialState: GetWeblabTreatmentResponse = {
    requestStatus: RequestStatus.NOT_LOADED,
    weblabTreatments: []
};

export default (state: GetWeblabTreatmentResponse = initialState, action: GetWeblabTreatmentComplete): GetWeblabTreatmentResponse => {
    switch (action.type) {
        case GET_WEBLAB_START:
            return state;
        case GET_WEBLAB_COMPLETE:
            return {
                requestStatus: RequestStatus.SUCCESS,
                weblabTreatments: action.weblabs
            };
        default:
            return state;
    }
};